import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFooter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 518,
	height: 313,
	viewBox: "0 0 518 313",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M98.2466 255.627L97.0418 254.939C96.713 254.751 96.6098 254.325 96.7862 253.99C96.9074 253.76 97.0296 253.499 97.0964 253.273C97.2383 252.795 97.1375 252.049 97.1054 251.843C97.0997 251.806 97.0962 251.77 97.0966 251.733C97.099 251.485 97.1275 250.464 97.4264 249.974C97.6746 249.566 98.3755 249.281 98.6418 249.185C98.7108 249.16 98.7834 249.15 98.8563 249.158C99.112 249.187 99.7482 249.309 100.066 249.809C100.351 250.257 100.339 251.168 100.066 251.624C99.9247 251.859 99.3593 252.213 99.5117 252.442L100.134 253.375C100.29 253.61 100.28 253.919 100.108 254.143L99.097 255.457C98.896 255.718 98.5329 255.791 98.2466 255.627Z",
			fill: "#FFBB96"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.7783 249.644C95.1134 250.293 97.0982 251.623 97.0982 251.623C97.0982 251.623 97.178 250.381 97.7581 249.809C98.2097 249.363 99.2429 249.314 99.2429 249.314C99.2429 249.314 99.8467 248.307 99.7378 247.829C99.6147 247.288 99.1347 247.056 98.5829 247.004C97.8892 246.938 97.7345 247.71 97.0982 247.994C96.7261 248.16 96.2905 247.959 96.1083 248.324C95.9261 248.688 96.6479 248.964 96.4382 249.314C96.29 249.561 95.9845 249.442 95.7783 249.644Z",
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.7481 255.088C98.2643 255.222 97.4731 254.794 96.9538 254.459C96.6188 254.243 96.2117 254.149 95.8343 254.277C95.0596 254.541 93.7435 255.109 93.1384 256.077C91.19 259.195 90.9805 265.584 90.9795 268.161C90.9792 268.806 91.4629 269.337 92.1025 269.42L104.574 271.047C105.4 271.155 106.116 270.485 106.046 269.655C105.722 265.828 104.774 256.291 103.202 253.933C102.768 253.282 101.766 253.117 101.046 253.088C100.547 253.068 100.128 253.407 99.8933 253.848C99.6235 254.355 99.2149 254.958 98.7481 255.088Z",
			fill: "#FFC45F"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_15894_38407)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M84.7241 261.522C84.7241 261.522 87.6402 260.543 89.6734 260.202C91.9046 259.828 95.1177 258.222 95.1177 258.222L93.9628 261.522C93.9628 261.522 90.9287 263.667 89.1785 263.667C87.4282 263.667 84.7241 263.172 84.7241 263.172V261.522Z",
				fill: "#FFC45F"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.9052 249.997L53.708 256.403C53.708 256.403 68.7518 258.695 78.2896 260.693C86.8914 262.494 99.6887 265.873 102.131 266.522C102.34 266.578 102.541 266.419 102.541 266.202V264.906C102.541 264.43 102.337 263.978 101.975 263.669C101.127 262.945 99.4942 261.576 98.2518 260.693C93.5781 257.371 90.3517 256.452 85.0536 254.259C80.9988 252.58 75.093 250.705 72.2247 249.822C71.1312 249.485 69.9595 249.552 68.9052 249.997Z",
			fill: "#18A0FB",
			fillOpacity: .2,
			stroke: "#FA4969",
			strokeWidth: .329954
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.788 289.32C152.394 291.842 151.022 295.172 150.483 296.415C150.357 296.706 150.041 296.857 149.733 296.782L143.612 295.279C140.834 294.597 139.211 291.709 140.072 288.982L143.143 279.257C143.305 278.744 143.597 278.282 143.991 277.915C145.102 276.881 146.797 276.798 148.004 277.718L151.071 280.057C152.166 280.892 152.868 282.144 152.936 283.519C153.02 285.214 153.06 287.573 152.788 289.32Z",
			fill: "#FA4969"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.7238 254.259L80.1045 261.353",
			stroke: "#FA4969",
			strokeWidth: .329954
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.407 297.289L53.132 292.241C52.6425 292.216 52.1735 292.087 51.7441 291.851C48.5535 290.093 34.2573 282.077 25.6622 274.881C16.7831 267.446 5.4743 253.719 3.04023 250.722C2.85752 250.497 3.01452 250.173 3.30323 250.198C9.51569 250.744 53.5449 254.742 81.2594 260.693C103.375 265.441 133.575 276.565 138.857 278.538C139.39 278.737 139.852 279.07 140.216 279.507L152.76 294.587C153.68 295.692 152.843 297.363 151.407 297.289Z",
			fill: "#FA4969"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.639 295.339L53.1336 292.241C52.6429 292.216 52.1727 292.087 51.7424 291.85C48.5487 290.091 34.2557 282.076 25.662 274.881C17.1673 267.768 9.89715 258.82 7.89513 256.279C7.70545 256.039 7.89493 255.696 8.19447 255.761C14.4542 257.114 54.1421 265.688 81.5892 271.581C105.016 276.611 110.56 284.353 110.934 284.912C110.95 284.936 110.963 284.956 110.978 284.98L116.102 292.786C116.842 293.915 115.988 295.407 114.639 295.339Z",
			fill: "#F0F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.9668 276.158C1.9668 276.158 14.3111 281.809 22.7871 282.958C31.1289 284.089 36.0319 280.567 44.3228 282.025C52.9434 283.542 56.2868 289.613 64.9643 290.759C73.4441 291.88 78.1391 287.405 86.6787 287.893C94.7082 288.352 98.7077 291.879 106.711 292.671C115.088 293.499 119.864 290.962 128.247 291.738C136.629 292.513 140.828 296.615 149.246 296.605C157.638 296.594 170.173 291.715 170.173 291.715L168.205 312.983L-0.000231955 297.425L1.9668 276.158Z",
			fill: "#74C6FD"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 152.073,
			y: 297.483,
			width: 89.3159,
			height: 1.94165,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 183.14,
			y: 305.25,
			width: 44.658,
			height: 1.94165,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 241.389,
			y: 305.25,
			width: 44.658,
			height: 1.94165,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M138 284L455.5 101",
			stroke: "black",
			strokeWidth: .235486
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M421.5 34.9868L450.583 96.3309",
			stroke: "black",
			strokeWidth: .235486
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M435.982 34.2803L452.231 97.3905",
			stroke: "black",
			strokeWidth: .235486
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M452.231 36.1641L455.646 98.6856",
			stroke: "black",
			strokeWidth: .235486
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M466.596 40.6384L456.353 99.6277",
			stroke: "black",
			strokeWidth: .235486
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M481.079 46.5254L458.59 100.216",
			stroke: "black",
			strokeWidth: .235486
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M495.207 55.3564L457.765 101.983",
			stroke: "black",
			strokeWidth: .235486
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M517.344 39.3433L458.59 101.865",
			stroke: "black",
			strokeWidth: .235486
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M417.026 26.156C417.381 31.0457 421.493 34.7512 421.493 34.7512C421.493 34.7512 426.748 30.761 429.624 30.6303C432.791 30.4863 435.505 34.7512 435.505 34.7512C435.505 34.7512 440.457 30.1593 447.874 31.4544C452.695 32.2961 452.695 36.1641 452.695 36.1641C452.695 36.1641 454.468 33.6891 460.355 35.5755C463.608 36.6176 466.942 41.1093 466.942 41.1093C466.942 41.1093 471.851 40.0987 474.713 41.1093C477.789 42.1956 481.071 46.5255 481.071 46.5255C481.071 46.5255 484.022 45.1126 486.612 46.5255C492.819 49.9109 494.612 55.8272 494.612 55.8272C494.612 55.8272 516.654 45.1126 517.814 38.0481C519.94 25.0963 504.077 9.03431 485.67 2.84287C472.718 -1.51358 450.465 -0.336224 439.155 2.84286C427.714 6.05854 416.385 17.3252 417.026 26.156Z",
			fill: "#74C6FD"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_15894_38407",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 417,
			y: 0,
			width: 102,
			height: 56,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M417.026 26.156C417.381 31.0457 421.493 34.7512 421.493 34.7512C421.493 34.7512 426.748 30.761 429.624 30.6303C432.791 30.4863 435.505 34.7512 435.505 34.7512C435.505 34.7512 440.457 30.1593 447.874 31.4544C452.695 32.2961 452.695 36.1641 452.695 36.1641C452.695 36.1641 454.468 33.6891 460.355 35.5755C463.608 36.6176 466.942 41.1093 466.942 41.1093C466.942 41.1093 471.851 40.0987 474.713 41.1093C477.789 42.1956 481.071 46.5255 481.071 46.5255C481.071 46.5255 484.022 45.1126 486.612 46.5255C492.819 49.9109 494.612 55.8272 494.612 55.8272C494.612 55.8272 516.654 45.1126 517.814 38.0481C519.94 25.0963 504.077 9.03431 485.67 2.84287C472.718 -1.51358 450.465 -0.336224 439.155 2.84286C427.714 6.05854 416.385 17.3252 417.026 26.156Z",
				fill: "#74C6FD"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_15894_38407)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M473.381 21.564C468.73 28.7151 466.007 41.1094 466.007 41.1094L479.901 50.7643C484.453 41.7059 482.491 38.99 490.733 29.2173C498.975 19.4447 511.456 16.6188 511.456 16.6188C511.456 16.6188 506.47 12.2819 502.978 9.90748C499.045 7.23277 492.381 3.90259 492.381 3.90259C492.381 3.90259 484.026 5.19776 473.381 21.564Z",
				fill: "#FA4969"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M443.165 12.1445C436.058 19.3923 435.394 35.8109 435.394 35.8109L450.582 38.7545C455.135 29.6961 453.055 29.4528 460.944 17.4432C468.833 5.43357 483.433 0.723472 483.433 0.723472C483.433 0.723472 481.39 0.507724 477.899 -1.86669C473.965 -4.5414 473.425 -2.45557 473.425 -2.45557C473.425 -2.45557 452.863 2.25394 443.165 12.1445Z",
				fill: "#FA4969"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M455.637 95.2914L456.497 94.8001C456.731 94.666 456.805 94.3621 456.679 94.123C456.593 93.9587 456.505 93.7722 456.458 93.6113C456.357 93.2699 456.428 92.7374 456.451 92.5903C456.455 92.5643 456.458 92.5384 456.458 92.512C456.456 92.3347 456.436 91.6066 456.222 91.2564C456.045 90.9657 455.545 90.7622 455.355 90.6934C455.306 90.6755 455.254 90.6682 455.202 90.6742C455.019 90.6951 454.565 90.7823 454.338 91.1387C454.135 91.4586 454.143 92.1087 454.338 92.4339C454.439 92.602 454.843 92.8547 454.734 93.0179L454.29 93.6837C454.178 93.8516 454.186 94.0721 454.309 94.2321L455.03 95.1697C455.173 95.3562 455.433 95.4082 455.637 95.2914Z",
			fill: "#FFBB96"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M460.816 91.607C460.152 91.607 456.458 92.434 456.458 92.434C456.458 92.434 456.401 91.5474 455.987 91.1389C455.665 90.8208 453.986 91.607 453.986 91.607C453.986 91.607 453.908 90.4206 453.986 90.0792C454.074 89.6935 456.065 89.0539 456.458 89.0165C456.953 88.9695 456.829 89.5202 457.283 89.723C457.548 89.8415 458.813 88.6603 459.638 89.3697C460.462 90.0792 461.939 90.0478 462.228 90.0792C463.288 90.1939 461.639 91.607 460.816 91.607Z",
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M450.57 96.9052L451.229 94.2698C451.258 94.1556 451.211 94.0358 451.113 93.9705C451.003 93.8969 450.856 93.9114 450.762 94.0053L448.998 95.7693C448.871 95.896 448.783 96.0561 448.745 96.231L448.332 98.0889C448.208 98.6461 448.604 99.1845 449.173 99.2319L450.06 99.3058C450.548 99.3465 450.923 99.7546 450.923 100.245V101.723C450.923 102.025 451.067 102.308 451.319 102.476C451.91 102.87 453.053 103.582 453.971 103.849C454.943 104.132 456.321 104.108 457.214 104.05C457.715 104.018 458.076 103.577 458.037 103.077L457.925 101.617C457.861 100.785 458.832 100.287 459.471 100.825L459.763 101.071C459.909 101.194 460.095 101.262 460.286 101.262C460.837 101.262 461.228 100.724 461.058 100.2L460.074 97.1657C460.019 96.9956 459.917 96.8446 459.779 96.7306L457.089 94.5044C456.781 94.2497 456.346 94.2168 456.004 94.4223L455.441 94.7596C455.111 94.9577 454.682 94.81 454.544 94.4507C454.388 94.0448 453.873 93.9218 453.551 94.2133L450.57 96.9052Z",
			fill: "#E4940B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M453.887 103.143L451.679 101.907C451.361 101.729 450.97 101.749 450.683 101.974C449.458 102.928 446.244 105.636 445.624 108.209C445.002 110.795 446.765 114.121 447.336 115.105C447.445 115.292 447.495 115.508 447.47 115.723L447.157 118.463C447.093 119.022 447.532 119.512 448.095 119.512C448.455 119.512 448.786 119.306 448.943 118.982L450.613 115.544C450.662 115.443 450.693 115.334 450.703 115.222L451.097 111.09C451.134 110.702 451.405 110.377 451.776 110.259C452.683 109.97 454.376 109.377 455.397 108.68C456.834 107.698 457.61 105.625 457.968 104.347C458.125 103.786 457.691 103.263 457.108 103.263H454.347C454.186 103.263 454.028 103.222 453.887 103.143Z",
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_15894_38407",
			x: 84.0642,
			y: 258.222,
			width: 11.7134,
			height: 6.76415,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: .659908 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .329954 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_15894_38407"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_15894_38407",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgFooter;
